/**
 * Role-membership helpers for the Reimbursements module.
 * Mirror the role-list checks scattered across Angular default-list / default-edit.
 */

import {
  ADMIN_OR_EXTERNAL_INSURANCE,
  ADMIN_OR_LIBERTY_DEFAULTS,
  CAN_MESSAGE_INSURANCE,
  COMPANY_PROPERTY_ROLES,
  LIBERTY_ROLES,
} from '../constants'

export function isAdminOrLibertyDefaults(roleName: string | undefined | null): boolean {
  return !!roleName && ADMIN_OR_LIBERTY_DEFAULTS.includes(roleName)
}

export function isAdminOrExternalInsurance(roleName: string | undefined | null): boolean {
  return !!roleName && ADMIN_OR_EXTERNAL_INSURANCE.includes(roleName)
}

export function canMessageInsurance(roleName: string | undefined | null): boolean {
  return !!roleName && CAN_MESSAGE_INSURANCE.includes(roleName)
}

export function isExternalInsurance(roleName: string | undefined | null): boolean {
  return roleName === 'EXTERNAL_INSURANCE'
}

export function isLibertyRole(roleName: string | undefined | null): boolean {
  return !!roleName && LIBERTY_ROLES.includes(roleName as (typeof LIBERTY_ROLES)[number])
}

export function canShowReimbursementMilestoneSaveSubmit(
  roleName: string | undefined | null,
): boolean {
  if (!roleName || !isLibertyRole(roleName)) return true
  return roleName === 'ROLE_ADMIN'
}

export function isCompanyPropertyRole(roleName: string | undefined | null): boolean {
  return !!roleName && COMPANY_PROPERTY_ROLES.includes(roleName)
}

export function isFieldLockedByStatus(
  roleName: string | undefined | null,
  claimLock: string | undefined | null,
  claimStatus: string | undefined | null,
  isFinalLedger: string | undefined | null,
): boolean {
  if (roleName === 'ROLE_ADMIN') return false
  return claimLock === 'Locked' || claimStatus === 'DENIED' || isFinalLedger === '1'
}
